import React from 'react';
import { routeStatusClasses } from 'components/common/tailwindClassnames';
import {
  HealthyStatusIcon,
  UnhealthyStatusIcon,
  DisabledStatusIcon,
  NeedsReviewStatusIcon,
} from 'components/common/ProjectIcons';

// Health dot color: green = healthy, red = unhealthy, gray = everything else
// (disabled, needs_review, unknown…). One mapping for every dot — the Route
// header and the flow map's account panel must never disagree about the same
// status. Normalizes case so a differently-cased API value can't split them.
export const getStatusDotColor = (status?: string) => {
  const key = String(status || '').toLowerCase();
  return key === 'healthy'
    ? 'bg-brand-accent-green'
    : key === 'unhealthy'
      ? 'bg-ui-status-error-destructive'
      : 'bg-unlisted-medium-gray';
};

export const getRouteStatus = (
  status: string,
  details_page: boolean,
  t: (key: string) => string,
) => {
  switch (status) {
    case 'healthy':
      return {
        text: t('Healthy'),
        style: routeStatusClasses.healthy(details_page),
        icon: <HealthyStatusIcon />,
      };
    case 'unhealthy':
      return {
        text: t('Unhealthy'),
        style: routeStatusClasses.unhealthy(details_page),
        icon: <UnhealthyStatusIcon />,
      };
    case 'needs_review':
      return {
        text: t('Needs Review'),
        style: routeStatusClasses.needsReview(details_page),
        icon: <NeedsReviewStatusIcon />,
      };
    case 'disabled':
      return {
        text: t('Disabled'),
        style: routeStatusClasses.disabled(details_page),
        icon: <DisabledStatusIcon />,
      };
    default:
      return {
        text: t('Unknown'),
        style: routeStatusClasses.unknown(details_page),
        icon: <NeedsReviewStatusIcon />,
      };
  }
};
